var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import React, { Component } from "react";
import Papa from "papaparse";
import { isString, isEqual, chunk, uniqBy } from "lodash";
import { injectIntl } from "@irati/utils/lang";
import { getErrorMessage } from "@irati/utils/lang/formatError";
import usersService from "@irati/identity/services/users";
import teamService from "@irati/identity/services/teams";
import { promiseSerialAll } from "@irati/utils/promise";
import adminTracking from "@irati-tracking/admin";
import { DONT_INCLUDE, TEAMS, getUserCSVHeaders, getUserCSVRows, csvRowToUser } from "@irati/admin/helpers/userCSV";
import authentication from "@irati/auth";
import Loading from "@irati/ui/src/Loading";
import IconButton from "@irati/ui/src/Button/IconButton";
import SelectAnOffice from "../../../components/Users/AddUsers/AddPeopleCSV/AddPeopleSelectAnOffice";
import AddPeopleCSV from "../../../components/Users/AddUsers/AddPeopleCSV/AddPeopleCSV";
import AddPeopleHeaders from "../../../components/Users/AddUsers/AddPeopleHeaders/AddPeopleHeaders";
import AddPeopleFailed from "../AddPeopleFailed/AddPeopleFailed";
import SuccessWithBackLink from "../../../components/SuccessWithBackLink";
import { ADD_PEOPLE_MULTIPLE } from "../../../routes/routeConfig";
export var InvitePeopleSteps;
(function (InvitePeopleSteps) {
    InvitePeopleSteps["ADD_PEOPLE_SELECT_OFFICE"] = "add_people-selected-office";
    InvitePeopleSteps["ADD_PEOPLE_CSV"] = "add_people-csv";
    InvitePeopleSteps["ADD_PEOPLE_HEADERS"] = "add_people-headers";
    InvitePeopleSteps["ADD_PEOPLE_FAILED"] = "add_people-failed";
    InvitePeopleSteps["ADD_PEOPLE_SUCCESS"] = "add_people-success";
})(InvitePeopleSteps || (InvitePeopleSteps = {}));
var TEAM_ERROR_MESSAGE = "admin.addMultiplePeople.teamErrorMessage";
var AddMultiplePeople = /** @class */ (function (_super) {
    __extends(AddMultiplePeople, _super);
    function AddMultiplePeople() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            currentStep: InvitePeopleSteps.ADD_PEOPLE_SELECT_OFFICE,
            headers: [],
            csv: [],
            isLoading: false,
            added: [],
            notAdded: [],
            teams: [],
            load: null,
            officeId: undefined
        };
        _this.updateHeader = function (value, idx) {
            var headers = _this.state.headers;
            headers.map(function (header, i) {
                if (value && value !== DONT_INCLUDE) {
                    if (header === value) {
                        headers.splice(i, 1, "");
                    }
                }
            });
            headers.splice(idx, 1, value);
            _this.setState({ headers: headers });
        };
        _this.onDrop = function (acceptedFiles) {
            var formatMessage = _this.props.formatMessage;
            var parsedRows = [];
            Papa.parse(acceptedFiles[0], {
                header: false,
                skipEmptyLines: true,
                step: function (row) {
                    if (row.data[0].find(function (value) { return value.trim() !== ""; })) {
                        parsedRows = __spreadArrays(parsedRows, [row.data[0]]);
                    }
                },
                complete: function () {
                    _this.setState({
                        headers: getUserCSVHeaders(parsedRows[0], formatMessage),
                        csv: getUserCSVRows(parsedRows),
                        currentStep: InvitePeopleSteps.ADD_PEOPLE_HEADERS
                    });
                },
                error: function (res) {
                    console.log(res);
                }
            });
        };
        _this.submitUsers = function () {
            // WARNING: this should be tested again and batched
            var _a = _this.state, headers = _a.headers, csv = _a.csv;
            var _b = _this.props, formatMessage = _b.formatMessage, goToSuccess = _b.goToSuccess;
            var adding = [];
            _this.setState({
                isLoading: true
            });
            csv.forEach(function (row) {
                var _a = csvRowToUser(headers, row), errors = _a.errors, user = _a.user;
                if (errors.length === 0) {
                    adding.push(user);
                }
                else {
                    user.error = errors;
                    _this.setState(function (_a) {
                        var notAdded = _a.notAdded;
                        notAdded.push(user);
                        return { notAdded: notAdded };
                    });
                }
            });
            var chunks = chunk(adding, 10);
            var funcs = chunks.map(function (userChunk) { return function () {
                var users = uniqBy(userChunk, "email");
                return Promise.all(users.map(function (user) {
                    return _this.handleCreate(user).catch(function (err) {
                        if (err !== formatMessage({ id: TEAM_ERROR_MESSAGE })) {
                            throw err;
                        }
                    });
                }));
            }; });
            return promiseSerialAll(funcs)
                .then(function () {
                var _a = _this.state, notAdded = _a.notAdded, added = _a.added;
                _this.setState({
                    isLoading: false
                });
                if (notAdded.length > 0) {
                    throw new Error();
                }
                adminTracking.createUsers();
                if (goToSuccess) {
                    goToSuccess(added.length);
                }
                else {
                    _this.showSuccess();
                }
            })
                .catch(function () {
                _this.setState({ currentStep: InvitePeopleSteps.ADD_PEOPLE_FAILED });
            });
        };
        _this.showSuccess = function () {
            _this.setState({ currentStep: InvitePeopleSteps.ADD_PEOPLE_SUCCESS });
            setTimeout(function () {
                _this.goBackToCSVStep();
            }, 2000);
        };
        _this.removeFromNotAdded = function (user, cb) {
            var notAdded = _this.state.notAdded;
            for (var i = 0; i < notAdded.length; i++) {
                if (isEqual(user, notAdded[i])) {
                    notAdded.splice(i, 1);
                    break;
                }
            }
            _this.setState({ notAdded: notAdded }, cb);
        };
        _this.addUserToNotAdded = function (user, error) {
            user.error = [error];
            _this.setState(function (_a) {
                var notAdded = _a.notAdded;
                notAdded.push(user);
                return { notAdded: notAdded };
            });
        };
        _this.addUserToAdded = function (user) {
            _this.setState(function (_a) {
                var added = _a.added;
                added.push(user);
                return { added: added };
            });
        };
        _this.handleCreateWithTeamField = function (user) {
            var formatMessage = _this.props.formatMessage;
            var teams = _this.state.teams;
            var userTeamNames = user.teams.split(", ");
            var userTeams = userTeamNames.map(function (teamName) {
                return teams.find(function (test) { return test.public_name === teamName; });
            });
            var invalidTeams = [];
            userTeams.forEach(function (teamName, i) {
                if (!teamName) {
                    invalidTeams.push(userTeamNames[i]);
                }
            });
            if (invalidTeams.length) {
                var invalidTeamsString = invalidTeams.join(", ");
                _this.addUserToNotAdded(user, formatMessage({ id: TEAM_ERROR_MESSAGE }, { team: invalidTeamsString, count: invalidTeams.length }));
                return Promise.resolve();
            }
            user.teamIds = userTeams.map(function (team) { return team.uuid; });
            _this.addOfficeToUser(user);
            return _this.createUser(user).catch(function (err) {
                user.teams = userTeams.map(function (team) { return team.public_name; }).join(", ");
                _this.addUserToNotAdded(user, getErrorMessage(err));
            });
        };
        _this.handleCreateWithoutTeamField = function (user) {
            _this.addOfficeToUser(user);
            return _this.createUser(user).catch(function (err) {
                user.teams = isString(user.teams) ? user.teams : null;
                _this.addUserToNotAdded(user, err.message);
            });
        };
        _this.createUser = function (data) {
            var user = {
                businessId: authentication.userTenant().uuid,
                firstName: data.firstName,
                lastName: data.lastName,
                email: data.email,
                teamIds: data.teamIds || [],
                language: authentication.userLocale()
            };
            var isAdmin = data.roles && data.roles.toLowerCase() === "admin";
            return usersService.create({ user: user }).then(function (createdUser) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!isAdmin) return [3 /*break*/, 2];
                            return [4 /*yield*/, usersService.makeUserGlobalAdmin(createdUser.uuid)];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            this.addUserToAdded(createdUser);
                            return [2 /*return*/];
                    }
                });
            }); });
        };
        _this.handleCreate = function (user) {
            _this.removeFromNotAdded(user);
            if (_this.state.headers.includes(TEAMS) && user.teams) {
                return _this.handleCreateWithTeamField(user);
            }
            return _this.handleCreateWithoutTeamField(user);
        };
        _this.handleSelectOffice = function (officeId) { return _this.setState({ officeId: officeId, currentStep: InvitePeopleSteps.ADD_PEOPLE_CSV }); };
        _this.goBackToCSVStep = function () {
            _this.setState({ currentStep: InvitePeopleSteps.ADD_PEOPLE_SELECT_OFFICE, notAdded: [], added: [] });
        };
        return _this;
    }
    AddMultiplePeople.prototype.componentDidMount = function () {
        var _this = this;
        var load = teamService.list(authentication.userTenant().uuid).then(function (teams) {
            _this.setState({ teams: teams });
        });
        this.setState({ load: load });
    };
    AddMultiplePeople.prototype.addOfficeToUser = function (user) {
        if (!user.teams) {
            user.teams = [];
        }
        if (this.state.officeId) {
            user.teams.push(this.state.officeId);
        }
        return user;
    };
    AddMultiplePeople.prototype.render = function () {
        var _a = this.state, load = _a.load, currentStep = _a.currentStep, added = _a.added, notAdded = _a.notAdded, headers = _a.headers, csv = _a.csv, isLoading = _a.isLoading;
        var _b = this.props, goBack = _b.goBack, gotoSuccess = _b.gotoSuccess, formatMessage = _b.formatMessage, alignLeft = _b.alignLeft;
        return (React.createElement(Loading, { load: load },
            goBack && React.createElement(IconButton, { onClick: goBack, icon: "backArrow" }),
            currentStep === InvitePeopleSteps.ADD_PEOPLE_SELECT_OFFICE && (React.createElement(SelectAnOffice, { back: goBack, selectOffice: this.handleSelectOffice })),
            currentStep === InvitePeopleSteps.ADD_PEOPLE_CSV && React.createElement(AddPeopleCSV, { alignLeft: alignLeft, back: goBack, onDrop: this.onDrop }),
            currentStep === InvitePeopleSteps.ADD_PEOPLE_HEADERS && (React.createElement(AddPeopleHeaders, { alignLeft: alignLeft, headers: headers, usersLength: csv.length, csv: csv.slice(0, 5), updateHeader: this.updateHeader, isLoading: isLoading, submitUsers: this.submitUsers, back: this.goBackToCSVStep })),
            currentStep === InvitePeopleSteps.ADD_PEOPLE_FAILED && (React.createElement(AddPeopleFailed, { headers: headers, notAdded: notAdded, added: added, handleCreate: this.handleCreate, removeUser: this.removeFromNotAdded, gotoSuccess: gotoSuccess || this.showSuccess, back: this.goBackToCSVStep })),
            currentStep === InvitePeopleSteps.ADD_PEOPLE_SUCCESS && (React.createElement(SuccessWithBackLink, { message: formatMessage({ id: "admin.components.addPeopleSuccess.headerTwo.addedPeople" }, { uploadedCount: added.length }), to: ADD_PEOPLE_MULTIPLE }))));
    };
    return AddMultiplePeople;
}(Component));
export default injectIntl(AddMultiplePeople);
